import { authReducer } from './reducer';
import { initialAuthState } from './state';

const AUTH_MODULE_NAME = 'auth';

export { AUTH_MODULE_NAME, initialAuthState, authReducer };
